/**
 * @desc 保存附件
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.AssociatedFilesRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/associatedFiles/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
